import * as React from "react";
import { Row, Col, Empty } from "antd";
import { ValidateIsTrainer, addDays } from "../../shared/Common";
import "./SchoolTrainingList.scss";
import EqSchoolTrainingCollapse from "../eqSchoolTrainingCollapse/EqSchoolTrainingCollapse";
import { useAuthState } from "../../context/Context";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { EqEventUserType } from "../../shared/enums";
import { useRef } from "react";

// This Component is for school training List
// This splits data in today tomorrow and later trainings separately
// on dashboard it will not titles if data not available

// right now its any but data should be school dto
import { addMonths } from "date-fns";
import { IEventType, IGetSchoolTrainingDto, IProductOPtions, IUpdateProductDto } from "../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";
import { IEqUiSelectModel, IGetPopulation } from "../../shared/interfaces/ILocationDto";
import { EqUiPaymentAccount, IHorseData, ISchoolStudents, ITrainerOption } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import { IGetSchoolTrainingInfoDto } from "../../shared/interfaces/GetSchoolTrainingInfoDto";
import { IEqEventData } from "../../shared/interfaces/IEqEventDto";
import { ITrainingInfoDto } from "../../shared/interfaces/ITrainingInfoDtos";
import { EqEntityProductDto } from "../../shared/interfaces/IProduct";
import { IProductDto } from "../../shared/Product/IProduct";
import { EqEntityHorse, IStudentHorseList } from "../../shared/interfaces/horse/IHorses";
import { EqUiStudentGroup } from "../../shared/interfaces/IUserGroupDto";
import { GetSchoolStudentsDto } from "../../shared/interfaces/schoolTraining/school";
import { ISelectOption } from "../../shared/Interfaces";
export interface IEqEventSplit {
    today: IGetSchoolTrainingInfoDto[];
    tomorrow: IGetSchoolTrainingInfoDto[];
    later: IGetSchoolTrainingInfoDto[];
}
export interface ISchoolTrainingList {
    trainingList: ITrainingInfoDto[] | IGetSchoolTrainingInfoDto[] | IEqEventData[] |IGetSchoolTrainingInfoDto[];
    //trainingList: any;
    trainersOptions: ISelectOption[];
    productOptions?: IProductOPtions[];
    products: EqEntityProductDto[] | IProductDto[];
    areas?: IEqUiSelectModel[];
    weekDays?: IEqUiSelectModel[];
    eventTypes: IEventType[];
    population?: IGetPopulation[];
    groupPopulation?: IGetPopulation[];
    trainerStudents?: EqUiStudentGroup[];
    studentHorsesList?: IStudentHorseList[];
    schoolStudents?: ISchoolStudents[];
    // if trainer
    trainerSchoolStudents?: GetSchoolStudentsDto[];
    schoolStudentHorsesList?: any;
    SchoolsTrainersOptionsList?: any;

    removeEventFunc?: (trainingData: IGetSchoolTrainingInfoDto, refund?: boolean) => void;
  removeAttendeeFunc?: (data: any) => void;
    onCreateOrUpdateSchoolTraining?: (newData: any, oldData: any) => void;
    stripeAccountInfo?: EqUiPaymentAccount;

}
const SchoolTrainingList = ({
  trainingList,
  trainersOptions,
  productOptions,
  products,
  areas,
  weekDays,
  eventTypes,
  population,
  groupPopulation,
  trainerStudents,
  studentHorsesList,
  schoolStudents,
  trainerSchoolStudents,
  schoolStudentHorsesList,
  SchoolsTrainersOptionsList,
  removeEventFunc,
  removeAttendeeFunc,
  onCreateOrUpdateSchoolTraining,
  stripeAccountInfo,
  ...rest
}: ISchoolTrainingList) => {

  const userDetails: any = useAuthState();
  const location = useLocation();
  const navigate = useNavigate();


  
    const trainingRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
    const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get('id'); // <-- Get the 'id' from query string
      
  const isTrainer: boolean = ValidateIsTrainer(userDetails);
  const { t, i18n } = useTranslation();
  const [eventData, setEventData] = React.useState({} as IEqEventSplit);
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long", // Correctly typed as "long" | "short" | "narrow" | undefined
    day: "2-digit",  // Correctly typed as "numeric" | "2-digit" | undefined
    month: "short",  // Correctly typed as "numeric" | "2-digit" | "long" | "short" | "narrow" | undefined
    year: "numeric", // Correctly typed as "numeric" | "2-digit" | undefined
};
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayTime = today.getTime();

    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    const tomorrowTime = tomorrow.getTime();

    const dayAfterTomorrow = new Date();
    dayAfterTomorrow.setHours(48, 0, 0, 0);
    const dayAfterTomorrowTime = dayAfterTomorrow.getTime();


    const [todayIsCollapseAll, setIsTodayCollapseAll] = React.useState(false);

    const todayCollapseAll = () => {
        setIsTodayCollapseAll(!todayIsCollapseAll);
        eventData?.today.map((item: any) => {
            item.display = !todayIsCollapseAll;
        });
    };

    const [tomorrowIsCollapseAll, tomorrowSetIsCollapseAll] =
        React.useState(false);

    const tomorrowCollapseAll = () => {
        tomorrowSetIsCollapseAll(!tomorrowIsCollapseAll);
        eventData?.tomorrow.map((item: any) => {
            item.display = !tomorrowIsCollapseAll;
        });
    };

    const [laterIsCollapseAll, laterSetIsCollapseAll] = React.useState(false);

    const laterCollapseAll = () => {
        laterSetIsCollapseAll(!laterIsCollapseAll);
        eventData?.later.map((item: any) => {
            item.display = !laterIsCollapseAll;
        });
    };


    React.useEffect(() => {
      if (id && trainingList?.length > 0) {
        // Use a small delay to ensure the DOM is fully rendered
        const timeoutId = setTimeout(() => {
          const trainingElement = trainingRefs.current[id];
          if (trainingElement) {
            // Scroll to the specific training
            trainingElement.scrollIntoView({ behavior: "smooth", block: "center" });
  
            // Add a temporary highlight effect
            trainingElement.style.border = "2px solid #FF8838"; // Highlight color
            trainingElement.style.transition = "border 0.5s ease";
            trainingElement.style.padding="4px"
  
            // Remove the highlight after a few seconds
            setTimeout(() => {
              trainingElement.style.border = "none";
            }, 3000); // Highlight duration
          }
        }, 100); // Small delay to ensure DOM rendering
  
        // Cleanup the timeout to avoid memory leaks
        return () => clearTimeout(timeoutId);
      }
    }, [id, trainingList]); // Run this effect when `id` or `eventList` changes

    React.useEffect(() => {


        var formedData = {} as IEqEventSplit;
    //This is Where we are Creating a List Of Riding Course Lessons. This will Now be added in the informatio tab 
        if (trainingList?.length > 0) {
            let data = trainingList as IGetSchoolTrainingInfoDto[];
            formedData.today = data?.filter(
        (opt: any) => opt.startDate < tomorrowTime && opt.startDate >= todayTime
      );
            formedData.tomorrow = data?.filter(
        (opt: any) =>
          opt.startDate < dayAfterTomorrowTime && opt.startDate >= tomorrowTime
      );
            formedData.later = data?.filter(
        (opt: any) => opt.startDate > dayAfterTomorrowTime
      );
      setEventData(formedData);
    }
    //formedData.today = trainingList;
    console.log(trainersOptions);
    if (trainerSchoolStudents && schoolStudentHorsesList) {
      console.log(trainerSchoolStudents);
      console.log(schoolStudentHorsesList);
    }
  }, [trainingList, areas, weekDays, trainersOptions,stripeAccountInfo]);

    const GetSchoolStudents = (organizers: any): any[] => {
        let value : any[] = [];
        const ownerOrganizer = organizers.find(
            (organizer: any) => organizer.eventUserType === EqEventUserType.Owner
        );
        if (trainerSchoolStudents) {
            value = trainerSchoolStudents.filter((x: any) => {
                if (x.user.email === ownerOrganizer.user.email) {
                    var result = x.schoolStudentsDto;
                    return [...result];
                }
            });
        }

        if (value.length > 0) {
            return value[0].schoolStudentsDto;
        } else {
            return value;
        }
    };



    const GetSchoolStudentHorseList = (organizers: any): any[] => {
        let value: any = [];
        const ownerOrganizer = organizers.find(
            (organizer: any) => organizer.eventUserType === EqEventUserType.Owner
        );
        if (schoolStudentHorsesList) {
            value = schoolStudentHorsesList.filter((x: any) => {
                if (x.key === ownerOrganizer.user.email) {
                    var result = x.studentHorsesList;
                    return [...result];
                }
            });
        }

        if (value.length > 0) {
            return value[0].studentHorsesList;
        } else {
            return value;
        }
    };
    const GetSchoolTrainers = (organizers: any): any[] => {
        let value: any = [];
        const ownerOrganizer = organizers.find(
            (organizer: any) => organizer.eventUserType === EqEventUserType.Owner
        );

        if (SchoolsTrainersOptionsList) {
            value = SchoolsTrainersOptionsList.filter((x: any) => {
                if (x.key === ownerOrganizer.user.email) {
                    var result = x.trainersOptions;
                    return [...result];
                }
            });
        }

        if (value.length > 0) {
            return value[0].trainersOptions;
        } else {
            return value;
        }
    };


    const GetSchoolProductOption = (item: any): [] => {
        let value = [] as any;

        if (item.product) {
            let obj = {
                key: item.productId,
                value: item.product.title,
                label: item.product.title,
                limit: item.product.limit,
            };
            value.push(obj)
        }

        return value;

    };
    return (
        <>
            {eventData?.later?.length > 0 ||
                eventData?.tomorrow?.length > 0 ||
                eventData?.today?.length > 0 ? (
                <>
                    {eventData?.today?.length > 0 ? (
                        <>
                            <div className="eq-el-container">
                                <Row>
                                    <Col flex="auto">
                                        <h4 className="eq-el-heading">{t("today")}</h4>
                                    </Col>
                                    <Col className="eq-el-dateHeading">
                                        <h5 className="eq-el-date">
                                            {new Date().toLocaleDateString(t("dateLang"), options as any)}
                                        </h5>
                                    </Col>
                                </Row>

                {eventData.today
                .sort((a: any, b: any) => a.startDate - b.startDate) // Sort by startTime
                .map((item: any, index: number) => (
                  <div 
                  key={index}
                  ref={(el) => (trainingRefs.current[item.id] = el)} // Assign ref to each training
                >
                    <EqSchoolTrainingCollapse
                      key={index}
                      training={item}
                      trainersOptions={
                        isTrainer
                          ? GetSchoolTrainers(item.organizers)
                          : trainersOptions
                      }
                      productOptions={
                        isTrainer
                        ? GetSchoolProductOption(item)
                        : productOptions
                        }
                      products={products}
                      eventTypes={eventTypes}
                      areas={areas}
                      weekDays={weekDays}
                      population={population}
                      groupPopulation={groupPopulation}
                      schoolStudents={
                        isTrainer
                          ? GetSchoolStudents(item.organizers)
                          : schoolStudents
                      }
                      studentHorsesList={
                        isTrainer
                          ? GetSchoolStudentHorseList(item.organizers)
                          : studentHorsesList
                      }
                      removeEventFunc={removeEventFunc}
                      removeAttendeeFunc={removeAttendeeFunc}
                      onCreateOrUpdateSchoolTraining={
                        onCreateOrUpdateSchoolTraining
                      }
                    stripeAccountInfo={stripeAccountInfo}

                    ></EqSchoolTrainingCollapse>
                  </div>
                ))}
              </div>
            </>
          ) : (
            location.pathname === "/school/activityBoard" && (
              <div className="eq-el-container">
                <Row>
                  <Col flex="auto">
                    <h4 className="eq-el-heading">{t("today")}</h4>
                  </Col>
                  <Col className="eq-el-dateHeading">
                    <h5 className="eq-el-date">
                    {new Date().toLocaleDateString(t("dateLang"),options as any)}
                    </h5>
                  </Col>
                </Row>
              </div>
            )
          )}

                    {eventData?.tomorrow?.length > 0 ? (
                        <>
                            <div className="eq-el-container">
                                <Row>
                                    <Col flex="auto">
                                        <h4 className="eq-el-heading">{t("tomorrow")}</h4>
                                    </Col>
                                    <Col className="eq-el-dateHeading">
                                        <h5 className="eq-el-date">
                                            {addDays(new Date(), 1).toLocaleDateString(t("dateLang"), options)}
                                        </h5>
                                    </Col>
                                </Row>


                {eventData.tomorrow
                .sort((a, b) => a.startDate - b.startDate) // Sort by startTime
                .map((item, index: number) => (
                  <div 
                  key={index}
                  ref={(el) => (trainingRefs.current[item.id] = el)} // Assign ref to each training
                >
                  <EqSchoolTrainingCollapse
                    key={index}
                    training={item}
                    trainersOptions={
                      isTrainer
                        ? GetSchoolTrainers(item.organizers)
                        : trainersOptions
                    }
                    productOptions={
                      isTrainer
                      ? GetSchoolProductOption(item)
                      : productOptions
                      }
                    products={products}
                    eventTypes={eventTypes}
                    areas={areas}
                    weekDays={weekDays}
                    population={population}
                    groupPopulation={groupPopulation}
                    schoolStudents={
                      isTrainer
                        ? GetSchoolStudents(item.organizers)
                        : schoolStudents
                    }
                    studentHorsesList={
                      isTrainer
                        ? GetSchoolStudentHorseList(item.organizers)
                        : studentHorsesList
                    }
                    removeEventFunc={removeEventFunc}
                    removeAttendeeFunc={removeAttendeeFunc}
                    onCreateOrUpdateSchoolTraining={
                      onCreateOrUpdateSchoolTraining
                    }
                    stripeAccountInfo={stripeAccountInfo}

                  ></EqSchoolTrainingCollapse>
                  </div>
                ))}
              </div>
            </>
          ) : (
            location.pathname === "/school/activityBoard" && (
              <div className="eq-el-container">
                <Row>
                  <Col flex="auto">
                    <h4 className="eq-el-heading">{t("tomorrow")}</h4>
                  </Col>
                  <Col className="eq-el-dateHeading">
                    <h5 className="eq-el-date">
                    {addDays(new Date(), 1).toLocaleDateString(t("dateLang"), options)}
                    </h5>
                  </Col>
                </Row>
              </div>
            )
          )}

                    {eventData?.later?.length > 0 ? (
                        <>
                            <div className="eq-el-container">
                                <h4 className="eq-el-heading">{t("later")}</h4>

                {eventData.later
                .sort((a: any, b: any) => a.startDate - b.startDate) // Sort by startTime
                  .map((item: any, index: number) => (
                    <div 
                    key={index}
                    ref={(el) => (trainingRefs.current[item.id] = el)} // Assign ref to each training
                  >
                  <EqSchoolTrainingCollapse
                    key={index}
                    training={item}
                    trainersOptions={
                      isTrainer
                        ? GetSchoolTrainers(item.organizers)
                        : trainersOptions
                    }
                    productOptions={
                      isTrainer
                      ? GetSchoolProductOption(item)
                      : productOptions
                      }
                    products={products}
                    eventTypes={eventTypes}
                    areas={areas}
                    weekDays={weekDays}
                    population={population}
                    groupPopulation={groupPopulation}
                    schoolStudents={
                      isTrainer
                        ? GetSchoolStudents(item.organizers)
                        : schoolStudents
                    }
                    studentHorsesList={
                      isTrainer
                        ? GetSchoolStudentHorseList(item.organizers)
                        : studentHorsesList
                    }
                    removeEventFunc={removeEventFunc}
                    removeAttendeeFunc={removeAttendeeFunc}
                    onCreateOrUpdateSchoolTraining={
                      onCreateOrUpdateSchoolTraining
                    }
                    stripeAccountInfo={stripeAccountInfo}
                  ></EqSchoolTrainingCollapse>
                  </div>
                ))}
              </div>
            </>
          ):(

            location.pathname === "/school/activityBoard" && (
              <div className="eq-el-container">
                <Row>
                  <Col flex="auto">
                  <h4 className="eq-el-heading">{t("later")}</h4>
                  </Col>
                
                </Row>
              </div>)
          )}
        </>
      ) : (
        <div className="eq-el-container">
          <Empty description={t("noTrainingsAvailable")} />
        </div>
      )}
    </>
  );
};
export default SchoolTrainingList;
